import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import KpiResultsPanel from './KpiResultsPanel';//eslint-disable-line import/no-named-as-default
import IndicatorResultsPanel from '../indicators/IndicatorResultsPanel';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as localStorage from '../../../localStorage/localStorage';
import * as animationHelper from "../../../helpers/animationHelper";

class KpiResultsList extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            kpis: [],//kpiHelper.getKpis(appHelper.getArrayObjectByKey(localStorage.bites),"bite_id",this.props.callbacks.getBiteId()),
            userDataKpis: appHelper.getArrayObjectByKey(this.props.userData.bites, "bite_id", this.props.callbacks.getBiteId()).kpis,
            renderableKpis: [],
            renderableIndicators:[],
            completeKpis:[],
            activeKpi:{},
            completeIndicators:[],
            activeIndicator:{},
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            icon: {
                src: "",
            },
            screenStatus:"",
            isReviewMode: false,
            checkComplete: false,
            updateKpis: false,
            kpiMenuData:{
                menu:[],
                currentKpi:{},
                onMenuSelect:{},
                idKey: "kpi_id",
                labelKey: "label"
            },
            indicatorMenuData:{
                menu:[],
                currentIndicator:{},
                onMenuSelect:{},
                idKey: "indicator_id",
                labelKey: "label"
            },
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            isComplete: false,
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.getKpisToDisplay = this.getKpisToDisplay.bind(this);
        this.onSelectKpi = this.onSelectKpi.bind(this);
        this.onKpiComplete = this.onKpiComplete.bind(this);
        this.getIndicatorsToDisplay = this.getIndicatorsToDisplay.bind(this);
        this.onSelectIndicator = this.onSelectIndicator.bind(this);
        this.onIndicatorComplete = this.onIndicatorComplete.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {

        this.getAssets();
        this.getScreenStatus();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
        this.getKpisToDisplay();
        this.getIndicatorsToDisplay();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                userDataKpis: appHelper.getArrayObjectByKey(nextProps.userData.bites, "bite_id", this.props.callbacks.getBiteId()).kpis,
                updateKpis: true
            });
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                continue_label: appHelper.getLocaleString("continue_label"),
                updateKpis: true
            });
        }
    }

    componentDidUpdate(){

        if(this.state.checkComplete){
            this.onComplete();
        }

        if(this.state.updateKpis){
            this.getKpisToDisplay();
        }
    }
    getScreenStatus(){
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status,
            isReviewMode: true,
        });
    }

    getObjectStatus() {
        if(this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.onComplete();
        }else{
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)){
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                }else{
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if(objectUserData.status === objectConstants.STATUS_COMPLETE){
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true,  isReviewMode: true});
            }else{
                this.setState({checkComplete: true});
            }

        }

    }
    getKpisToDisplay(){

        let bite_id = this.props.callbacks.getBiteId();
        let bite = appHelper.getArrayObjectByKey(localStorage.bites,"bite_id",bite_id);
        let kpis = kpiHelper.getKpis(bite);
        if(kpis.length > 0) {
            let renderableKpis = [];
            for (let i = 0; i < kpis.length; i++) {
                let kpi = kpis[i];

                let kpiDataObj = {
                    kpi_id: kpi.kpi_id,
                    data: kpi,
                    userData: appHelper.getArrayObjectByKey(this.state.userDataKpis, "kpi_id", kpi.kpi_id)
                };
                renderableKpis = dataHelper.immutablePush(renderableKpis, kpiDataObj);
            }

            if (this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_SCORE_ONLY) {
                renderableKpis = kpiHelper.removeObjectivesFromKpisToDisplay(renderableKpis);
            } else if (this.state.screenObject.display_method === objectConstants.RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY) {
                renderableKpis = kpiHelper.removeScoreFromKpisToDisplay(renderableKpis);
                if (this.state.screenObject.hide_objectives.length > 0) {
                    renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
                }
            } else {
                if (this.state.screenObject.hide_objectives.length > 0) {
                    renderableKpis = kpiHelper.removeKpisFromKpisToDisplay(renderableKpis, this.state.screenObject.hide_objectives);
                }
            }

            let kpiMenu = kpiHelper.setKpiMenuData(renderableKpis);
            let activeIndex = 0;

            if (appHelper.isDefined(this.state.activeKpi) && appHelper.isDefined(this.state.activeKpi.kpi_id)) {
                activeIndex = appHelper.getArrayObjectIndexByKey(renderableKpis, "kpi_id", this.state.activeKpi.kpi_id);
            }

            this.setState({
                updateKpis: false,
                renderableKpis: Object.assign([], renderableKpis),
                activeKpi: renderableKpis[activeIndex],
                completeKpis: this.state.status === objectConstants.STATUS_COMPLETE ? renderableKpis : this.state.completeKpis,
                kpiMenuData: Object.assign({}, this.state.kpiMenuData, {
                    menu: kpiMenu,
                    currentKpi: kpiMenu[0],
                    onMenuSelect: this.onSelectKpi,
                })
            });
        }
    }

    onSelectKpi(result){
        let activeKpi = appHelper.getArrayObjectByKey(this.state.renderableKpis,"kpi_id",result.kpi_id);
        let activeMenuItem = appHelper.getArrayObjectByKey(this.state.kpiMenuData.menu,"kpi_id",result.kpi_id);
        this.setState({
            activeKpi:activeKpi,
            kpiMenuData: Object.assign({},this.state.kpiMenuData, {
                currentKpi:activeMenuItem,
            })
        });
    }

    getIndicatorsToDisplay(){
        let bite_id = this.props.callbacks.getBiteId();
        let bite = appHelper.getArrayObjectByKey(localStorage.bites,"bite_id",bite_id);
        let indicators = bite.indicators;
        if(indicators.length > 0 && this.state.screenObject.display_method !== objectConstants.RESULT_DISPLAY_METHOD_SCORE_ONLY) {
            let userDataIndicators = appHelper.getArrayObjectByKey(this.props.userData.bites, "bite_id", bite_id).indicators;
            let renderableIndicators = [];
            for (let i = 0; i < indicators.length; i++) {
                let indicator = indicators[i];
                let indicatorDataObj = {
                    indicator_id: indicator.indicator_id,
                    data: indicator,
                    userData: appHelper.getArrayObjectByKey(userDataIndicators, "indicator_id", indicator.indicator_id)
                };

                let hiddenIndex = appHelper.getArrayObjectIndexByKey(this.state.screenObject.hide_idicators,"indicator_id",indicatorDataObj.indicator_id);
                if(hiddenIndex === -1) {
                    renderableIndicators = dataHelper.immutablePush(renderableIndicators, indicatorDataObj);
                }
            }

            let indicatorMenu = kpiHelper.setKpiMenuData(renderableIndicators);
            let activeIndex = 0;

            if (appHelper.isDefined(this.state.activeIndicator.indicator_id)) {
                activeIndex = appHelper.getArrayObjectIndexByKey(renderableIndicators, "indicator_id", this.state.activeIndicator.indicator_id);
            }

            this.setState({
                updateKpis: false,
                renderableIndicators: Object.assign([], renderableIndicators),
                activeIndicator: renderableIndicators[activeIndex],
                completeIndicators: this.state.status === objectConstants.STATUS_COMPLETE ? renderableIndicators : this.state.completeKpis,
                indicatorMenuData: Object.assign({}, this.state.indicatorMenuData, {
                    menu: indicatorMenu,
                    currentIndicator: indicatorMenu[0],
                    onMenuSelect: this.onSelectIndicator,
                })
            });
        }
    }

    onSelectIndicator(result){
        let activeIndicator = appHelper.getArrayObjectByKey(this.state.renderableIndicators,"indicator_id",result.indicator_id);
        let activeMenuItem = appHelper.getArrayObjectByKey(this.state.indicatorMenuData.menu,"indicator_id",result.indicator_id);
        this.setState({
            activeIndicator:activeIndicator,
            indicatorMenuData: Object.assign({},this.state.indicatorMenuData, {
                currentIndicator:activeMenuItem,
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {
        if (appHelper.isDefined(this.state.screenObject.icon)) {
            let icon = appHelper.getIconAsset(this.state.screenObject.icon);
            if (appHelper.isDefined(icon) && icon.src.length > 0) {
                this.setState({icon: icon});
            }
        }
    }
    show() {
        let objectRef = this.objectRef.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: this.getObjectStatus
        };
        animationHelper.showHeight(params);
    }


    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }


    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`${this.state.screenObject.asset_id}_asset`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop, true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});

        if(this.state.renderableKpis.length === this.state.completeKpis.length && this.state.renderableIndicators.length === this.state.completeIndicators.length && !this.state.isComplete) {
            this.setState({isComplete: true});
            let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                if (!hasNextObject) {
                    this.handleProgression();
                    this.enableProgression();
                } else {
                    this.enableProgression();
                }

            } else {
                this.handleProgression();
            }
            this.scrollToTop();
        }
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked(){
        this.setState({showProgressionButton: false});
        if(this.props.callbacks.hasNextObject(this.props.index)){
            this.handleProgression();
        }else{
            this.props.callbacks.navigateToNextScreen();
        }
    }


    onKpiComplete(kpi){
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeKpis,"kpi_id",kpi.kpi_id);
        if(index === -1){
            this.setState({
                completeKpis: dataHelper.immutablePush(this.state.completeKpis,kpi),
                checkComplete: true,
            });
        }
    }

    onIndicatorComplete(indicator){
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeIndicators,"indicator_id",indicator.indicator_id);
        if(index === -1){
            this.setState({
                completeIndicators: dataHelper.immutablePush(this.state.completeIndicators,indicator),
                checkComplete: true,
            });
        }
    }

    render() {
        return (

            <div className={`object-container`} ref={this.objectRef}>
                {
                    this.state.screenObject.show_title
                    ?
                        <h4 className={objectConstants.DEFAULT_HEADING_CLASS} dangerouslySetInnerHTML={{__html:this.state.locale.label}} />
                    :
                        null
                }
                {this.state.renderableKpis.map(kpi =>
                    <KpiResultsPanel key={kpi.kpi_id} kpiData={kpi.data} userDataKpi={kpi.userData} bite_id={this.props.callbacks.getBiteId()} asset_id={this.state.screenObject.asset_id} onComplete={this.onKpiComplete} completeKpis={this.state.completeKpis}/>
                )}


                {this.state.screenObject.display_method !== objectConstants.RESULT_DISPLAY_METHOD_SCORE_ONLY && this.state.renderableIndicators.length > 0
                    ?
                    this.state.renderableIndicators.map(indicator =>
                        <IndicatorResultsPanel key={indicator.indicator_id} indicatorData={indicator.data} userDataIndicator={indicator.userData} bite_id={this.props.callbacks.getBiteId()} asset_id={this.state.screenObject.asset_id} onComplete={this.onIndicatorComplete} completeKpis={this.state.completeIndicators}/>
                    )
                    :
                    null
                }
                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>

        );
    }
}

KpiResultsList.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    index: PropTypes.number,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

KpiResultsList.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiResultsList);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiResultsList.js
 **/